// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"e5bdc67d7772e525","9777":"8b6419cfae7f9970"}[chunkId] + ".js";
};